export default {
  nav: {
    about: 'About',
    shows: 'Events',
    music: 'Music',
    contact: 'Contact'
  },
  hero: {
    tagline: 'Music that creates memories!',
    bookNow: 'Get a Quote',
    listen: 'Listen'
  },
  about: {
    title: 'About',
    paragraph1: 'The proposal is to transform your event into an unforgettable sonic experience, focused on connection, energy, and the emotion of the moment. The set is built in real time, feeling the event, the dance floor, and the rhythm of your guests.',
    paragraph2: 'Music with energy and feeling, researched, listened to, and chosen for an audience that has lived the best of several generations. Bringing energy, nostalgia, modernity, novelties, and good vibes — all in the right dosage!',
    features: {
      curation: 'Real-Time Curation',
      curationDesc: 'The set is guided by the vibe and atmosphere of the venue',
      collaboration: 'Collaboration & Openness',
      collaborationDesc: 'Requests and suggestions are welcomed',
      respect: 'Timeless Respect',
      respectDesc: 'All ages will have their space',
      professionalism: 'Simplicity & Professionalism',
      professionalismDesc: 'Complete sound equipment'
    },
    stats: {
      events: 'Events',
      years: 'Years',
      satisfaction: 'Satisfaction'
    }
  },
  shows: {
    title: 'Upcoming Events',
    subtitle: 'Check where I\'ll be playing',
    getTickets: 'More Info'
  },
  music: {
    title: 'Musical Style',
    subtitle: 'Real-time set, feeling the vibe',
    genres: {
      hits: 'Hits & Funk',
      world: 'World Music',
      rock: 'Rock & Flashback',
      dance: 'Dance & Electronic'
    },
    quote: 'Work done with heart, especially for an audience that has lived many good things... and still wants to live much more'
  },
  contact: {
    title: 'Let\'s Create Your Next Memory?',
    subtitle: 'Request a personalized quote and elevate your event',
    namePlaceholder: 'Name',
    emailPlaceholder: 'Email',
    phonePlaceholder: 'Phone',
    locationPlaceholder: 'Event Location',
    messagePlaceholder: 'Tell me about your event...',
    sendButton: 'Request Quote',
    successMessage: 'Request sent successfully! I\'ll get back to you soon.',
    errorMessage: 'Error sending request. Please try again or contact directly.'
  },
  footer: {
    rights: 'All rights reserved',
    tagline: 'Because the right music moves. Connects. Transforms.',
    devBy: 'Developed by'
  }
}
